export function getInitials(name, fallback = 'CL') {
  if (!name || typeof name !== 'string') {
    return fallback;
  }

  const words = name
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (words.length === 0) {
    return fallback;
  }

  const initials = words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');

  return initials || fallback;
}
